export const ERROR_TRIGGERED = 'GLOBAL_ERROR_TRIGGERED';
export const CLEAR_STORE = 'CLEAR_STORE_FOR_GLOBAL_ERROR_CONTAINER';

export const REQUEST_ACCESS_STARTED = 'REQUEST_ACCESS_STARTED';
export const REQUESTED_ACCESS = 'REQUESTED_ACCESS';
export const REQUEST_ACCESS_FAILED = 'REQUEST_ACCESS_FAILED';



// WEBPACK FOOTER //
// ./src/app/stores/global-errors-display/global-errors-display-constants.js